import { Spin } from "antd";
import styled from "styled-components";
import { ReactElement } from "react";

import { IconLoading } from "@components";

interface IProps {
    children?: HTMLElement | HTMLElement[] | ReactElement<any, any>;
}

export const ComponentSpinPage = (props: IProps) => {
    return (
        <StyledSpinPage>
            <Spin spinning={true}>{props.children}</Spin>
        </StyledSpinPage>
    );
};

const StyledSpinPage = styled.div`
    margin-top: 4rem;
    width: 100%;
    height: 100%;
`;
